import Head from "next/head";
import ContentPolicyComponent from "../src/supportModule/view/ContentPolicy";
import { useTranslation } from "react-i18next";

export default function ContentPolicy() {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{t('content-policy-or-utsav-hindu-temple-online-puja-and-prasad')}</title>
        <meta
          name="keywords"
          content={t('utsav-utsavapp-content-policy-of-utsav-app-online-puja-booking-online-puja-online-darshan-hindi-devotional-puja-app-darshan-app-online-puja-app-free-online-puja-hinduism-sanatan-dharma-lord-shiva-lord-krishna-indian-heritage-virtual-festivals-virtual-puja-locate-various-temple-connect-with-community-temples-of-india-festivals-community-platform-download-utsav-app-community-events-india-events-bhagavad-gita-yoga-devotion-festivals-spirituality-divine-god-belief')}
        />
        <meta
          name="description"
          content={t('explore-utsav-apps-content-policy-promoting-a-safe-and-respectful-space-for-users-while-ensuring-ethical-content-sharing-and-a-positive-community-experience')}
        />

        <meta property="og:title" content={t('utsav-app-my-temple-and-festivals')} />
        <meta
          property="og:description"
          content={t('content-policy-of-utsav-app-utsav-is-india-and-apos-s-most-loved-online-puja-booking-app-offer-pujas-at-shaktipeeth-jyotirlingas-and-famous-hindu-mandirs-of-kashi-vrindavan-ujjain-watch-puja-darshan-and-receive-holy-prasad-at-your-home-directly-from-temple')}
        />

        <meta property="og:url" content="https://utsavapp.in/content-policy" />
        <meta
          property="og:image"
          content="https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj"
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://utsavapp.in/content-policy" />
      </Head>

      <ContentPolicyComponent />
    </>
  );
}
